<template>
  <b-row>
    <transition name="slide">
      <b-col cols="12" xl="12">
        <b-input-group>
          <b-form-input v-model="filter" placeholder="Type to Search" />
          <b-input-group-append>
            <b-btn @click="filter = ''">Clear</b-btn>
          </b-input-group-append>
        </b-input-group>
        <b-table :hover="hover"
                  :striped="striped"
                  :bordered="bordered"
                  :small="small"
                  :fixed="fixed"
                  responsive="sm"
                  :items="users"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @row-clicked="rowClicked"
                  :filter="filter"
                  @filtered='onFiltered'>
          <template slot="id" slot-scope="data">
            <strong>{{data.item.id}}</strong>
          </template>
          <template slot="name" slot-scope="data">
            <strong>{{data.item.name}}</strong>
          </template>
          <template slot='action' slot-scope="data">
            <b-button variant="danger" class="action-btn" @click="deleteUser(data.item.id, $event)" v-b-popover.hover.top="'Delete'">
              <i class="fa fa-trash-o" aria-hidden="true"></i>
            </b-button>
          </template>
        </b-table>
        <nav>
          <b-pagination size="sm" :total-rows="getRowCount(users)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
        <b-button variant="primary" @click="$eventBus.$emit('newUserModal')">
          Add new user
        </b-button>
      </b-col>
    </transition>
    <user-modal />
  </b-row>
</template>

<script>
import UserModal from '@/views/modals/UserModal'
import {mapGetters} from 'vuex'
export default {
  name: 'Users',
  components: {
    UserModal
  },
  props: {
    caption: {
      type: String,
      default: 'Users'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      users: [],
      fields: [
        {key: 'id'},
        {key: 'first_name'},
        {key: 'last_name'},
        {key: 'email'},
        {key: 'action'}
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      filter: null
    }
  },

  created () {
    if (this.currentUser.isDigital) {
      this.fields.push({key: 'roles'})
    }
    this.loadUsers()
  },

  methods: {
    loadUsers () {
      this.$http.get('/users')
        .then(response => this.users = response.data)
        .catch((e) => console.log(e))
    },
    getRowCount (items) {
      return items.length
    },
    userLink (id) {
      return `users/${id.toString()}`
    },
    rowClicked (item) {
      const userLink = this.userLink(item.id)
      this.$router.push({path: userLink})
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    deleteUser (userId, event) {
      if (event) event.stopPropagation()
      if (!confirm('Do you really want to delete?')){
        return false
      }
      this.$http.delete('/users/' + userId)
        .then(function(){
          this.users = this.users.filter(user => user.id !== userId)
        }.bind(this))
        .catch((e) => console.log(e))
    }
  },

  computed: {
    ...mapGetters(['currentUser']),
  }

}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
<style>
.action-btn {
  font-size: 16px;
  border-radius: 30px;
  border-color: transparent !important;
  height: 35px;
  width: 35px;
  padding: 0;
  text-align: center;
}
.card .card-header {
  font-family: 'Cooper Hewitt Semibold';
  text-transform: uppercase;
  color: #3493B2;
  letter-spacing: 2px;
}
</style>
